import { MenuDetail, SettingUsecaseInterface } from "./usecase.d";
import * as SettingReducer from "./reducer";
import { ActionType } from "./types";
import { BootstrapEntity } from "../../services/Bootstrap/bootstrap.entity";
import { LoginModeType } from "./reducer";

export class SettingUsecase implements SettingUsecaseInterface {
  dispatch: SettingReducer.SettingDispatch;

  constructor(dispatch: SettingReducer.SettingDispatch) {
    this.dispatch = dispatch;
  }

  setMenuDetail(menu: MenuDetail) {
    this.dispatch({
      type: ActionType.SetMenuDetail,
      menuDetail: menu,
    });
  }

  setTenantInfo(tenantInfo: BootstrapEntity) {
    this.dispatch({
      type: ActionType.SetTenantInfo,
      tenantInfo,
    });
  }

  setLoginMode(loginMode?: LoginModeType) {
    this.dispatch({
      type: ActionType.SetLoginMode,
      loginMode,
    });
  }
}
